import React from 'react';
import { inject, observer } from 'mobx-react';
import { Checkbox, message } from 'antd';
import { addContentPath } from '../../../../util/pathUtil';

@inject('portalLoginStore')
@observer
class E7Form extends React.Component {
    constructor(props) {
        super(props);
        this.getLoginForm = this.getLoginForm.bind(this);
        this.onLabelClick = this.onLabelClick.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.getDynamicPassword = this.getDynamicPassword.bind(this);
        this.onLogin = this.onLogin.bind(this);
    }

    componentDidMount() {
        const { portalLoginStore } = this.props;
        const { state = {} } = portalLoginStore;
        const { cacheAccount: loginId, langId } = state;
        portalLoginStore.getLoginForm({ loginId, langId });
    }

    componentDidUpdate() {
        const { portalLoginStore } = this.props;
        const { loginFormDataLoading } = portalLoginStore;
        if (loginFormDataLoading) {
            portalLoginStore.doAfterLoginRenderEvent();
        }

        const _this = this;
        jQuery('.e7login-form-input').unbind().keydown(function (e) {
            e = e || window.event;
            const key = e.keyCode || e.which || e.charCode;
            if (key == 13) {
                const inputs = jQuery('.e7login-form-input');
                const idx = inputs.index(this);
                const nxtIdx = idx + 1;
                const nxtInput = jQuery(`.e7login-form-input:eq(${nxtIdx})`);
                if (nxtInput.length > 0) {
                    nxtInput.focus();
                } else {
                    _this.onLogin();
                }
            }
        });
    }

    render() {
        const { portalLoginStore, getState } = this.props;
        let { state, dynamicPasswordTime, onPasswordForget, onRememberChange, onValidateCodeChange, labelObj } = portalLoginStore;
        state = getState();
        const {
            isRememberPW,
            isRememberAccount,
            isRememberPassword,
            cacheAccount,
            cachePassword,
            loginSettingInfo = {},
            loginFormItems,
            loginFormHiddenItems,
            loginSetting = {},
            validateCode,
        } = state;
        const { loginForm = {} } = loginSettingInfo;
        const { color } = loginForm;
        const { needforgotpassword, validateCodeKey = '' } = loginSetting;
        const validateCodeSrc = `${validateCode}&validateCodeKey=${validateCodeKey}`;
        return (
            <div className="e7login-form">
                {
                    loginFormItems.map((item, index) => {
                        let defaultValue = '';
                        if (item.atype == 'account') {
                            defaultValue = cacheAccount;
                        } else if (item.atype == 'password') {
                            defaultValue = cachePassword;
                        }

                        let itemComp = (
                            <div key={index} className="e7login-form-item">
                                <input type={item.type} id={item.id} name={item.name} autoComplete="new-password" className="e7login-form-input" placeholder={item.label} defaultValue={defaultValue} onBlur={() => item.atype == 'account' && this.getLoginForm()} onChange={this.onInputChange} />
                            </div>
                        );

                        if (item.atype == 'dynamicPassword') {
                            itemComp = (
                                <div key={index} className="e7login-form-item e7login-form-item-dp">
                                    <input type={item.type} id={item.id} name={item.name} autoComplete="new-password" className="e7login-form-input e7login-form-input-dp" placeholder={item.label} onChange={this.onInputChange} />
                                    <div className="e7login-form-dynamic" style={{ color }}>
                                        {
                                            dynamicPasswordTime > 0 ? (
                                                <span className="e7login-form-dynamic-text" style={{ color: '#ccc' }}>
                                                    {labelObj.resend}({dynamicPasswordTime}s)
                                                </span>
                                            ) : (
                                                <span className="e7login-form-dynamic-text" onClick={this.getDynamicPassword}>
                                                    {labelObj.send}
                                                </span>
                                            )
                                        }
                                    </div>
                                </div>
                            );
                        }

                        if (item.atype == 'validatecode') {
                            itemComp = (
                                <div key={index} className="e7login-form-item e7login-form-item-vc">
                                    <input type={item.type} id={item.id} name={item.name} className="e7login-form-input e7login-form-input-vc" placeholder={item.label} onChange={this.onInputChange} />

                                    <div className="e7login-form-vc-img">
                                        <img src={addContentPath(validateCodeSrc)} alt="" onClick={onValidateCodeChange} />
                                    </div>
                                </div>
                            );
                        }

                        return itemComp;
                    })
                }
                {
                    loginFormHiddenItems.map((item, index) => <div key={index} style={{ display: 'none' }} dangerouslySetInnerHTML={{ __html: item.html }} />)
                }
                <div className="e7login-form-remember">
                    {
                        needforgotpassword == '1' && (
                            <div className="e7login-form-remember-forget" title={labelObj.forgetPassword}>
                                <span onClick={() => onPasswordForget()}>{labelObj.forgetPassword}</span>
                            </div>
                        )
                    }
                    <div className={`e7login-form-remember-content ${isRememberPW == '1' ? '' : 'e7login-display-hidden'}`}>
                        <div className={'e7login-form-remember-account'} title={labelObj.rememberAccount}>
                            <Checkbox ecId={`${this && this.props && this.props.ecId || ''}_Checkbox@yzgk3s`} checked={isRememberAccount} onChange={e => onRememberChange('account', e.target.checked)}>{labelObj.rememberAccount}</Checkbox>
                        </div>
                        <div className={'e7login-form-remember-password'} title={labelObj.rememberPassword}>
                            <Checkbox ecId={`${this && this.props && this.props.ecId || ''}_Checkbox@8b314t`} checked={isRememberPassword} onChange={e => onRememberChange('password', e.target.checked)}>{labelObj.rememberPassword}</Checkbox>
                        </div>
                    </div>
                    <div className="e7login-form-clear" />
                </div>
            </div>
        );
    }

    getLoginForm() {
        const { portalLoginStore } = this.props;
        portalLoginStore.getLoginForm({}, (result = {}) => {
            const { loginSetting = {}, message: warningMsg } = result;
            const { userUsbType } = loginSetting;
            if (userUsbType == '6') {
                warningMsg && message.warning(warningMsg);
                portalLoginStore.setStateAndCache('loginType', 'QRCode');
            }
        });
    }

    onLabelClick(e) {
        jQuery(e.target.parentNode).find('input').focus();
    }

    onInputChange(e) {
        if (e.target.value) {
            jQuery(e.target.parentNode).find('.e7login-form-label').addClass('e7login-display-hidden');
        } else {
            jQuery(e.target.parentNode).find('.e7login-form-label').removeClass('e7login-display-hidden');
        }
    }

    getDynamicPassword() {
        const { portalLoginStore } = this.props;
        portalLoginStore.getDynamicPassword();
    }

    onLogin() {
        const { portalLoginStore } = this.props;
        portalLoginStore.onLogin();
    }
}

export default E7Form;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/e7login/formCloud/e7Form.js